<template>
  <ScreenDialog class="c2c-wx-share-dialog" ref="wxShareDialog" :isAppendToBody="true">
    <img :src="guideWxImg" alt="" class="share-wx_img" />
  </ScreenDialog>
</template>

<script lang="ts" setup>
import { userEnv } from '@tencent/wphk-base-utils';
import { ScreenDialog } from '@tencent/wphk-ui';
import { computed, ref } from 'vue-demi';
import { i18n } from '../../i18n';

defineExpose({ showDialog, hideDialog });

/** 微信分享弹窗 */
const wxShareDialog = ref<InstanceType<typeof ScreenDialog> | null>(null);
/** 微信分享图片 */
const guideWxImg = computed(() => (userEnv.isInMiniProgram() ? i18n('guideMpImgUrl') : i18n('guideWxImgUrl')));

function showDialog() {
  wxShareDialog.value?.show();
}

function hideDialog() {
  wxShareDialog.value?.hide();
}
</script>

<style lang="less">
@import (reference) '~@/less/main';
.c2c-wx-share-dialog {
  .midddialog {
    justify-content: flex-start !important;
    padding-top: 40 / @rem;
    img {
      width: 100%;
    }
  }
}
</style>
